import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface DashboardCardProps {
  title: string;
  value: number;
  icon: LucideIcon;
  change?: number;
  changeType?: 'positive' | 'negative' | 'neutral';
  className?: string;
  onClick?: () => void;
}

export const DashboardCard = ({ title, value, icon: Icon, change, changeType, className, onClick }: DashboardCardProps) => {
  return (
    <Card className={cn(className)} onClick={onClick}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        <Icon className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{value}</div>
        {change !== undefined && (
          <p className={`text-xs ${
            changeType === 'positive' ? 'text-green-600' : 
            changeType === 'negative' ? 'text-red-600' : 
            'text-muted-foreground'
          }`}>
            {change > 0 ? '+' : ''}{change} desde ayer
          </p>
        )}
      </CardContent>
    </Card>
  );
};